import { COISIntroduction } from '@repo/ui/COISIntroduction'
import { COISPartyDetails } from '@repo/ui/COISPartyDetails'
import { COISRefineYourSearch } from '@repo/ui/COISRefineYourSearch'
import { COISPossibleConflicts } from '@repo/ui/COISPossibleConflicts'
import { COISSummary } from '@repo/ui/COISSummary'
import { COISReviewParties } from '@repo/ui/COISReviewParties'
import { COISConfirmSearch } from '@repo/ui/COISConfirmSearch'
import { COISSelectClientMatter } from '@repo/ui/COISSelectClientMatter'
import { useCOISStore } from '@repo/store/useCOISStore'

export default [
  {
    stageLabel: 'Conflict of interest search',
    stageId: 'conflict',
    resetData: useCOISStore.getState().reset,
    steps: [
      {
        stepLabel: 'Introduction',
        stepId: 'introduction',
        stepDescription: 'Get started by reading the guide below',
        skippable: true,
        component: COISIntroduction,
        uniqueId: 'cois-introduction'
      },
      {
        stepLabel: 'Party details',
        stepDescription: 'Please enter the party details',
        stepId: 'party-details',
        skippable: false,
        component: COISPartyDetails,
        uniqueId: 'cois-party-details'
      },
      {
        stepLabel: 'Refine your search',
        stepDescription: 'Specify which custom data pages and fields to search against',
        stepId: 'refine-your-search',
        skippable: true,
        component: COISRefineYourSearch,
        uniqueId: 'cois-refine-your-search'
      },
      {
        stepLabel: 'Possible conflicts',
        stepDescription: `Review the conflicts table. Click 'Continue' if there are no conflicts, or exit if you do not wish to proceed`,
        stepId: 'possible-conflicts',
        skippable: true,
        component: COISPossibleConflicts,
        uniqueId: 'cois-possible-conflicts'
      },
      {
        stepLabel: 'Review parties',
        stepDescription: `To search against an additional party click 'Add party’ below and start again`,
        stepId: 'review-parties',
        skippable: true,
        component: COISReviewParties,
        uniqueId: 'cois-review-parties'
      },
      {
        stepLabel: 'Confirm search',
        stepDescription: 'Confirm you can act below',
        stepId: 'confirm-search',
        skippable: false,
        component: COISConfirmSearch,
        uniqueId: 'cois-confirm-search'
      },
      {
        stepLabel: 'Client & matter details',
        stepDescription: 'Select existing clients and matters, or and choose to create new clients and matters',
        stepId: 'client-matter-details',
        skippable: false,
        component: COISSelectClientMatter,
        uniqueId: 'cois-client-matter-details'
      },
      {
        stepLabel: 'Summary',
        stepDescription: 'Conflict of interest search complete',
        stepId: 'summary',
        skippable: true,
        component: COISSummary,
        uniqueId: 'cois-summary'
      }
    ]
  }
]
